import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/pilotage/prices', config);
}
const get = async (id) => {
    return FinanceApi.get('/pilotage/prices/' + id);
}
const store = async (data) => {
    return FinanceApi.post('/pilotage/prices', data);
}
const update = async (id, formData) => {
    return FinanceApi.put('/pilotage/prices/' + id, formData);
}
const del = async (id) => {
    return FinanceApi.delete('/pilotage/prices/' + id);
}

export default {
    getAll,
    update,
    get,
    store,
    del,
}
